import React, { useEffect, useState } from 'react';
import { API_BASE } from '../../../config/api.js';

const parseDistrictRows = (json) => {
  const list =
    Array.isArray(json?.data?.data) ? json.data.data :
    Array.isArray(json?.data) ? json.data :
    Array.isArray(json?.result) ? json.result :
    Array.isArray(json) ? json : [];

  return list
    .map((row, index) => {
      const district = String(
        row?.additionalinfo2 ??
        row?.AdditionalInfo2 ??
        row?.district ??
        row?.District ??
        row?.districtname ??
        row?.districtName ??
        row?.name ??
        ''
      ).trim();

      const count = Math.max(0, Number(
        row?.total ??
        row?.count ??
        row?.complaints ??
        row?.complaintCount ??
        row?.value ??
        0
      ) || 0);

      if (!district) return null;

      return {
        id: `${district.toLowerCase().replace(/[^a-z0-9]+/g, '-') || `district-${index}`}-${index}`,
        district,
        count,
      };
    })
    .filter(Boolean)
    .sort((a, b) => b.count - a.count)
    .slice(0, 5);
};

const parseReferralRows = (json) => {
  const list =
    Array.isArray(json?.data?.data) ? json.data.data :
    Array.isArray(json?.data) ? json.data :
    Array.isArray(json?.result) ? json.result :
    Array.isArray(json) ? json : [];

  return list
    .map((row, index) => {
      const referral = String(
        row?.referral ??
        row?.serviceReferral ??
        row?.ServiceReferral ??
        row?.name ??
        row?.value ??
        ''
      ).trim();

      const count = Math.max(0, Number(
        row?.total ??
        row?.count ??
        row?.complaints ??
        row?.complaintCount ??
        0
      ) || 0);

      if (!referral) return null;

      return {
        id: `${referral.toLowerCase().replace(/[^a-z0-9]+/g, '-') || `referral-${index}`}-${index}`,
        referral,
        count,
      };
    })
    .filter(Boolean);
};

const DistrictDrillDownServiceReferralSection = () => {
  const [districtRows, setDistrictRows] = useState([]);
  const [districtErr, setDistrictErr] = useState('');
  const [referralRows, setReferralRows] = useState([]);
  const [referralErr, setReferralErr] = useState('');

  useEffect(() => {
    const ac = new AbortController();

    const loadDistrictRows = async () => {
      try {
        setDistrictErr('');

        const response = await fetch(`${API_BASE}/performance/district-wise-complaints?topN=5`, {
          headers: { Accept: 'application/json' },
          signal: ac.signal,
        });

        const text = await response.text();
        let json = null;
        try { json = text ? JSON.parse(text) : null; } catch {}

        if (!response.ok || json?.success === false) {
          throw new Error(json?.message || json?.error || text || 'Request failed');
        }

        setDistrictRows(parseDistrictRows(json));
      } catch (error) {
        if (error?.name === 'AbortError') return;
        setDistrictRows([]);
        setDistrictErr(error?.message || 'Failed to load district drill-down');
      }
    };

    loadDistrictRows();
    return () => ac.abort();
  }, []);

  useEffect(() => {
    const ac = new AbortController();

    const loadReferralRows = async () => {
      try {
        setReferralErr('');

        const response = await fetch(`${API_BASE}/performance/service-referral-counts`, {
          headers: { Accept: 'application/json' },
          signal: ac.signal,
        });

        const text = await response.text();
        let json = null;
        try { json = text ? JSON.parse(text) : null; } catch {}

        if (!response.ok || json?.success === false) {
          throw new Error(json?.message || json?.error || text || 'Request failed');
        }

        setReferralRows(parseReferralRows(json));
      } catch (error) {
        if (error?.name === 'AbortError') return;
        setReferralRows([]);
        setReferralErr(error?.message || 'Failed to load service referrals');
      }
    };

    loadReferralRows();
    return () => ac.abort();
  }, []);

  return (
    <div className="perf-wide-row">
      <article className="perf-card">
        <div className="perf-card-head">
          <span>District Drill-down</span>
          <span className="perf-pill">Top 5</span>
        </div>
        <div className="perf-list">
          {districtRows.length ? (
            districtRows.map((row) => (
              <div key={row.id}>
                <span>{row.district}</span>
                <strong>{row.count}</strong>
                <em className="perf-pill">Count</em>
              </div>
            ))
          ) : (
            <div><span>No district data</span><strong>0</strong><em className="perf-pill">Count</em></div>
          )}
        </div>
        {districtErr ? <div className="perf-sub">{districtErr}</div> : null}
      </article>
      <article className="perf-card">
        <div className="perf-card-head">
          <span>Service Referral</span>
          <span className="perf-pill">Referral Mix</span>
        </div>
        <div className="perf-referral-list">
          <span>Referred To</span>
          {referralRows.length ? (
            referralRows.map((row, index) => (
              <button
                key={row.id}
                className={`perf-referral-item ${index === 0 ? 'active' : ''}`}
                type="button"
              >
                {row.referral} <em>{row.count.toLocaleString()}</em>
              </button>
            ))
          ) : (
            <button className="perf-referral-item active" type="button">
              No referral data <em>0</em>
            </button>
          )}
        </div>
        <div className="perf-sub">
          {referralErr || 'Updated daily based on referral tagging.'}
        </div>
      </article>
    </div>
  );
};

export default DistrictDrillDownServiceReferralSection;
